import React, { useState } from 'react';
import { updateDoc, doc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import DevisModalBase from './DevisModalBase';

/**
 * Modal d'édition de devis - Version compacte utilisant DevisModalBase
 */
const EditDevisModal = ({ devis, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  // Gestionnaire de modification de devis
  const handleUpdateDevis = async (devisData) => {
    const { selectedClient, lignesPrestations, contratParams, periodePrestation, preview } = devisData;

    if (!selectedClient || !preview) {
      alert('Veuillez sélectionner un client et vérifier les calculs');
      return;
    }

    setLoading(true);
    try {
      // Mettre à jour le devis dans Firestore
      const devisRef = doc(db, 'devis', devis.id);
      
      // Créer une copie des calculs avec le type de tarif garanti dans toutes les structures
      const calculsAvecTypeComplete = {
        ...preview,
        // S'assurer que le type de tarif est présent dans la structure contrat
        contrat: {
          ...(preview.contrat || {}),
          baseRateType: contratParams.baseRateType,
          type: contratParams.contractType,
          volumeHebdo: contratParams.weeklyHours
        },
        // S'assurer que le type de tarif est présent dans la configuration
        configuration: {
          ...(preview.configuration || {}),
          baseRateType: contratParams.baseRateType,
          versionCalcul: '2.0',
          avecCollaborateurs: true,
          tarifsPersonnalises: preview.configuration?.tarifsPersonnalises || false
        }
      };

      console.log('Sauvegarde du devis avec type de tarif:', {
        contratParams: contratParams,
        calculContrat: calculsAvecTypeComplete.contrat,
        calculConfiguration: calculsAvecTypeComplete.configuration
      });
      
      const updatedDevis = {
        ...devis,
        clientNom: `${selectedClient.lastName} ${selectedClient.firstName}`,
        clientEmail: selectedClient.email || '',
        clientTelephone: selectedClient.phoneNumber || '',
        clientAdresse: selectedClient.address || '',
        lignesPrestations: lignesPrestations,
        contratParams: contratParams, // SAUVEGARDER les paramètres du contrat
        calculs: calculsAvecTypeComplete, // Calculs avec type de tarif garanti
        montantHT: preview.totaux.totalCesu,
        montantTTC: preview.totaux.totalTTC,
        dateModification: new Date().toISOString(),
        // PRÉSERVER explicitement la date de validité et autres dates importantes
        dateCreation: devis.dateCreation, // Conserver la date de création originale
        dateValidite: devis.dateValidite, // Conserver la date de validité originale
        dateDebut: periodePrestation?.dateDebut ? Timestamp.fromDate(periodePrestation.dateDebut) : null,
        dateFin: periodePrestation?.dateFin ? Timestamp.fromDate(periodePrestation.dateFin) : null,
        numero: devis.numero, // Conserver le numéro original
        statut: devis.statut // Conserver le statut original
      };

      await updateDoc(devisRef, updatedDevis);

      console.log('✅ Devis sauvegardé avec succès avec le type de tarif:', contratParams.baseRateType);
      alert(`✅ Devis ${devis.numero} modifié avec succès !`);
      onSuccess && onSuccess(updatedDevis);
      onClose();
    } catch (error) {
      console.error('Erreur modification devis:', error);
      alert('❌ Erreur lors de la modification du devis');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DevisModalBase
      mode="edit"
      devis={devis}
      onClose={onClose}
      onSuccess={onSuccess}
      title={`Modifier le devis ${devis?.numero}`}
      subtitle="Modifiez les prestations et les paramètres tarifaires"
      actionLabel={loading ? "Modification..." : "Modifier le devis"}
      onAction={handleUpdateDevis}
      loading={loading}
    />
  );
};

export default EditDevisModal;
